import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { colors } from '../../styles/theme'

const S = {}

S.TabNavigation = styled.div`
  ${({ isOutline }) =>
    isOutline
      ? css`
          &:focus {
            outline: 0.25rem solid ${colors.silverChalice};
            outline-offset: 0;
          }
        `
      : css`
          &:focus {
            box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;
            outline: 2px solid transparent;
            outline-offset: 2px;
          }

          &:active {
            box-shadow: none;
          }
        `};

  ${({ isIcon }) =>
    isIcon &&
    css`
      line-height: 0;
    `};

  &[role='menuitem'] {
    box-sizing: border-box;
    margin: 0;
    padding: 0.75rem 1.25rem;
    border: none;
    outline: none;
    background: transparent;
    width: 100%;
    text-align: left;
    cursor: pointer;
    transition: 0.15s cubic-bezier(0.5, 0, 0.25, 1);
    transition-property: color, background-color;
    font-family: inherit;
    font-size: 0.875rem;
    line-height: 1.4;
    color: ${colors.silverChalice};

    &:not([data-disabled='true']):hover, &:focus {
      background-color: ${colors.woodsmoke};
      color: ${colors.white};
    }
  }
`

export default S
